import React, { useContext, useRef } from "react";
import { useState, useEffect } from "react";
import Modal from "@mui/material/Modal";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";
import {
  Box,
  FormControl,
  TextField,
  Button,
  Tooltip,
  Checkbox,
  Typography,
  FormControlLabel,
  FormHelperText,
  Container,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemText,
  Divider,
} from "@mui/material";
import AuthContext from "../store/AuthContext";
import DownloadIcon from "@mui/icons-material/Download";
import html2pdf from "html2pdf.js";
import PinInput from "react-pin-input";
import ModalHeader from "../modals/ModalHeader";
import ModalFooter from "../modals/ModalFooter";
import { dilliPaysign, Logo } from "../iconsImports";
import { postJsonData } from "../network/ApiController";
import ApiEndpoints, { BASE_URL } from "../network/ApiEndPoints";
import { useLocation } from "react-router-dom";
import { datemonthYear, myDateDDMMTT, myDateDDMMyy } from "../utils/DateUtils";
import axios from "axios";
const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 12,
    lineHeight: 1.3,
  },
  section: {
    marginBottom: 9,
  },
  viewer: {
    width: window.innerWidth,
    height: window.innerHeight,
  },
  image: {
    width: 160,
  },
  stamp_image: {
    width: 200,
    marginLeft: -15,
  },
  bigtext: {
    fontSize: 200,
    letterSpacing: 0.4,
    lineHeight: 1.2,
  },
  text: {
    fontSize: 11,
    letterSpacing: 0.4,
    marginBottom: 30,
    lineHeight: 1.5,
    textAlign: "justify",
    wordWrap: "break-word",
  },
});

const AdminAgreement = () => {
  const [open, setOpen] = useState(false);
  const [currentDateTime, setCurrentDateTime] = useState("");

  const [request, setRequest] = useState(false);
  const [aadhaar, setAadhaar] = useState("");
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpRefrance, setOtpRefrance] = useState("");
  const [aadhaarError, setAadhaarError] = useState(false);
  const [message, setMessage] = useState("Your are not sign Agreement");
  const [checked, setChecked] = useState(false);
  const [showForPDF, setShowForPDF] = useState(false);
  const [date, setDate] = useState();
  const [otpError, setOtpError] = useState(false);
  const authCtx = useContext(AuthContext);
  const user = authCtx.user;
  const token = authCtx.token;
  const location = useLocation();
  const [kycImages, setKycImages] = useState({});
  const [imageUrl, setImageUrl] = useState(null);
  // Extract query parameters from the URL
  const queryParams = new URLSearchParams(location.search);
  console.log("imageUrl", imageUrl);

  // Parse and store the required state data
  const stateData = {
    name: queryParams.get("name"),
    role: queryParams.get("role"),
    state: queryParams.get("state"),
    establishment: queryParams.get("establishment"),
    username: queryParams.get("username"),
    name: queryParams.get("name"),
    rowData: queryParams.get("rowData"),
    kyc_images: queryParams.get("kyc_images"),
    ip: queryParams.get("ip"),
    pan: queryParams.get("pan"),
    type: queryParams.get("type"),
  };
  useEffect(() => {
    if (stateData.kyc_images) {
      setKycImages(JSON.parse(stateData.kyc_images));
    }
  }, [stateData.kyc_images]);

  // Log the extracted data
  console.log("The rowData is:", stateData.rowData);

  // Optional: Handle undefined or null rowData
  if (!stateData.rowData) {
    console.warn("rowData is not present in the URL query parameters.");
  }

  const contentRef = useRef();

  useEffect(() => {
    if (!stateData?.rowData) return; // Ensure stateData.rowData is available

    postJsonData(
      ApiEndpoints.AGEMENT_DATE,
      { id: stateData.rowData },
      setRequest,
      (res) => {
        const date = res.data.data.created_at;
        setMessage(
          `This agreement is electronically transmitted on ${myDateDDMMTT(
            date
          )} from IP address  ${stateData.ip}. and verified by (${
            stateData?.establishment
          }/${stateData?.name}) having PAN NO ${stateData?.pan} `
        );

        // setDate(res.data.data.created_at);
        setChecked(true); // Update the state with the date
      },
      (err) => {
        console.error("Error fetching date:", err); // Handle errors
      }
    );
  }, [stateData?.rowData]); // Empty

  const handleDownload = () => {
    setShowForPDF(true);

    setTimeout(() => {
      document.getElementById("downloadButton").classList.add("hide-in-pdf");

      const element = contentRef.current;
      const options = {
        margin: [0.5, 0.5, 0.5, 0.5],
        filename: "Distributor_Agreement.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 3, letterRendering: true, useCORS: true },
        jsPDF: { unit: "in", format: "A4", orientation: "portrait" },
      };

      html2pdf()
        .set(options)
        .from(element)
        .save()
        .finally(() => {
          setShowForPDF(false);

          document
            .getElementById("downloadButton")
            .classList.remove("hide-in-pdf");
        });
    }, 500);
  };
  const getImage = async (fileName) => {
    const headers = {
      Authorization: `Bearer ${token}`,
    };

    try {
      const response = await axios.post(
        `${BASE_URL}/${ApiEndpoints.GET_FILES}`,
        { fileName },
        { responseType: "blob", headers: headers }
      );

      const imageUrl = URL.createObjectURL(new Blob([response.data]));
      return imageUrl;
    } catch (error) {
      console.error("Error fetching image:", error);
      return null;
    }
  };

  const fetchImage = async (filename) => {
    const fileName = kycImages[filename];
    const url = await getImage(fileName);
    if (url) {
      // setOpenModal(true);
      setImageUrl(url);
    }
  };
  React.useEffect(() => {
    fetchImage("signature");
  }, [stateData]);
  const getCurrentDateTime = () => {
    const date = new Date();

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year} `;
  };

  useEffect(() => {
    setCurrentDateTime(getCurrentDateTime());

    const interval = setInterval(() => {
      setCurrentDateTime(getCurrentDateTime());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  function handleChange(e) {
    setChecked(!checked);
    setOpen(!checked);
  }
  // function handleValue(e) {
  //   const { name, value } = e.target;
  //   if (name === "aadhaar") {
  //     setAadhaar(value);
  //   } else if (name === "otp") {
  //     setOtp(value);
  //   }
  // }

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    // width: "40%",
    boxShadow: 24,
    fontFamily: "Poppins",
    height: "max-content",
    overflowY: "scroll",
    p: 2,
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setAadhaarError("");
    setOtpError("");

    // Aadhaar validation
    if (aadhaar.length !== 12) {
      setAadhaarError("Enter Valid Aadhaar Number");
      return;
    }

    // Helper function to get stateData's location
    const getLocation = (e) =>
      new Promise((resolve, reject) => {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            (position) => resolve(position.coords),
            (error) => reject(error)
          );
        } else {
          reject(new Error("Geolocation is not supported by this browser."));
        }
      });

    try {
      // Retrieve stateData's location
      const { latitude, longitude } = await getLocation();

      // Send Aadhaar and location data (no OTP required)
      postJsonData(
        ApiEndpoints.SEND_OTP_Okyc, // You might want to rename the API endpoint if OTP is not being sent
        { aadhaarNumber: aadhaar, latitude, longitude },
        setRequest,
        (res) => {
          console.log("Aadhaar submitted successfully", res);
          setOtpRefrance(res?.data?.data?.otpReferenceID);
          setIsOtpSent(true); // Set OTP sent status to true
        },
        (err) => {
          console.error("Error submitting Aadhaar", err);
          setAadhaarError("Error submitting Aadhaar. Please try again.");
        }
      );
    } catch (error) {
      console.error("Error fetching location:", error);
      setAadhaarError("Unable to fetch location. Please try again.");
    }
  };
  const verifyOTP = async (e) => {
    e.preventDefault();
    setOtpError("");
    const getLocation = () =>
      new Promise((resolve, reject) => {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            (position) => resolve(position.coords),
            (error) => reject(error)
          );
        } else {
          reject(new Error("Geolocation is not supported by this browser."));
        }
      });
    if (!isOtpSent) {
      // If OTP is not sent, validate Aadhaar number
      if (aadhaar.length !== 12) {
        setAadhaarError("Enter Valid Aadhaar Number");
        return;
      }
      // Proceed with OTP sending if Aadhaar is valid
      try {
        const { latitude, longitude } = await getLocation();

        postJsonData(
          ApiEndpoints.SEND_OTP_Okyc,
          { aadhaarNumber: aadhaar, latitude, longitude },
          setRequest,
          (res) => {
            console.log("OTP sent successfully", res);
            setOtpRefrance(res?.data?.data?.otpReferenceID);
            setIsOtpSent(true); // Set OTP sent status
          },
          (err) => {
            console.error("Error sending OTP", err);
            setOtpError("Error sending OTP. Please try again.");
          }
        );
      } catch (error) {
        console.error("Error fetching location:", error);
        setOtpError("Unable to fetch location. Please try again.");
      }
    } else {
      // OTP verification block
      if (otp.length === 6) {
        try {
          const { latitude, longitude } = await getLocation();

          // Verify OTP
          postJsonData(
            ApiEndpoints.VERIFY_OTP_OKYC,
            { otp, otpReferenceID: otpRefrance, latitude, longitude },
            setRequest,
            (res) => {
              console.log("OTP verified successfully", res);
              // setMessage(`This agreement  is electronically transmitted on ${myDateDDMMTT(
              //   date
              // )} from IP address ……………….. and verified by (${
              //   stateData?.establishment
              // }/${stateData?.name}) having PAN NO ${stateData?.pan} `);
              setChecked(true);
              handleDownload();

              handleClose();
            },
            (err) => {
              console.error("Error verifying OTP", err);
              setOtpError("Invalid OTP. Please try again.");
            }
          );
        } catch (error) {
          console.error("Error fetching location:", error);
        }
      } else {
        setOtpError("Enter a valid OTP.");
      }
    }
  };
  const handleCloseModel = () => {
    setAadhaar("");
    setOtp("");
    setIsOtpSent(false);
    setChecked(false);
    setOpen(false);
  };
  const handleClose = () => {
    setAadhaar("");
    setOtp("");
    setIsOtpSent(false);
    setOpen(false);
  };
  return (
    <>
      <div
        ref={contentRef}
        style={{
          padding: "20px",
          flexGrow: 1,
          fontFamily: "Arial, sans-serif",
          lineHeight: "1.6",
          maxWidth: "800px",
          margin: "0 auto",
          color: "#333",
          textAlign: "justify",
          overflowWrap: "break-word",
          wordWrap: "break-word",
          whiteSpace: "normal",
        }}
      >
        <Page size="A4" style={styles.page}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "20px",
              marginBottom: "10px",
            }}
          >
            {/* Logo on Left */}
            <img
              src={Logo} // ✅ Replace with actual logo path
              alt="DilliPay Logo"
              style={{
                width: "30%",
                height: "70px",
                marginRight: "15px",
              }}
            />

            <div style={{ textAlign: "center", flexGrow: 1 }}>
              <h2
                style={{
                  fontSize: "22px",
                  fontWeight: "bold",
                  margin: 0,
                }}
              >
                DILLIPAY TECHNOLOGIES LIMITED
              </h2>
              <p
                style={{
                  fontSize: "14px",
                  margin: "5px 0 0 0",
                }}
              >
                Plot No. 5, Second Floor, Pocket -5, Rohini Sector 24, New Delhi
                – 110085
              </p>
            </div>
          </div>
          <hr
            style={{
              border: "1px solid black",
              // marginBottom: "10px",
            }}
          />
          <Box
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              textAlign: "center",
              marginTop: "20px",
            }}
          >
            <Typography variant="h3" align="center" fontWeight="bolder">
              RETAILER AGREEMENT
            </Typography>
            {/* <Button onClick={()=>fetchImage("signature")}>fetch</Button> */}
            <Tooltip title="Download as PDF" arrow>
              <Button
                id="downloadButton"
                onClick={handleDownload}
                style={{
                  minWidth: "auto",
                  padding: 8,
                  mb: 1,
                }}
              >
                <DownloadIcon style={{ color: "black" }} />
              </Button>
            </Tooltip>
          </Box>
          <Typography
            variant="body1"
            style={{
              lineHeight: 1.6,
              textAlign: "justify",
              wordWrap: "break-word",
            }}
            paragraph
          >
            THIS Agreement is made as of this date between:
          </Typography>

          <Typography variant="h5" fontWeight="bold" gutterBottom>
            DILLIPAY TECHNOLOGIES LIMITED
          </Typography>
          <Typography variant="body1" paragraph>
            A company incorporated under The Companies Act, 2013, having its
            registered office at Plot No 5, Second Floor, Pocket 5, Sector 24,
            Rohini, Delhi-110085.
          </Typography>
          <Typography variant="body1" paragraph>
            (Hereinafter referred to as “DilliPay” which expression shall,
            unless repugnant to the context or meaning thereof, include their
            successors and permitted assigns) of the ONE PART; and
          </Typography>
          <Typography variant="h5" fontWeight="bold" paragraph>
            {stateData.establishment} ,{stateData.id} , {stateData.name},{" "}
            {stateData.username}
          </Typography>
          <Typography variant="body1" paragraph>
            (Hereinafter referred to as "RETAILER", which expression shall,
            unless repugnant to the context or meaning thereof, include their
            successors and permitted assigns) of the SECOND PART.
          </Typography>
          <Typography variant="body1" paragraph>
            The DilliPay and the Retailer are herein collectively referred to as
            the “Parties” and individually as a “Party.” WHEREAS
          </Typography>
          <Typography variant="body1" paragraph component="div">
            <ul>
              <li>
                <strong>DilliPay</strong> is a technology-based company engaged,
                inter alia, in providing software and platform services in the
                Fintech industry. It caters to a range of services including
                Domestic Money Transfer, Aadhaar Enabled Payment System (AEPS),
                Utility Bill Payments, Recharges, Travel Services, and more.
              </li>
              <li>
                <strong>DilliPay</strong> proposes to appoint Retailers in
                various cities and regions across India for the purpose of
                managing other retailers to be appointed by DilliPay in such
                areas and to perform various services offered by DilliPay. Such
                Retailers may also be referred to as Master Retailers (MD) or
                Retailers.
              </li>
              <li>
                The <strong>Retailer</strong> wishes to be appointed as a
                Retailer in the DilliPay-designated regional territory
                (hereinafter referred to as the "Territory") under the terms and
                conditions contained in this Retailer Agreement.
              </li>
              <li>
                The Parties agree and undertake that they shall abide by the
                terms and conditions of this Retailer Agreement and therefore
                sign this Agreement confirming their mutual commitment and
                intentions.
              </li>
            </ul>
          </Typography>

          <Typography
            variant="h4"
            sx={{
              fontSize: "1.8rem",
              fontWeight: "bold",
              marginBottom: 2,
            }}
          >
            1. APPOINTMENT OF THE RETAILER
          </Typography>
          <Typography variant="body1" paragraph>
            Subject to the terms and conditions contained in this Retailer
            Agreement, DilliPay hereby appoints the Retailer on a non-exclusive
            basis for the Territory to provide the services mentioned in
            Annexure-I (hereinafter referred to as "Services"), and the Retailer
            hereby agrees to provide the Services.
          </Typography>
          <Typography variant="body1" paragraph>
            DilliPay proposes to appoint Retailer (s) in the various cities and
            regions of the India for the purpose of managing retailers to be
            appointed by DilliPay in such cities and regions and to perform
            various services offered by DilliPay, and such Retailer may be
            referred to as Master Retailer (MD) or Retailer
          </Typography>
          <Typography variant="body1" paragraph>
            The Retailer may describe himself as DilliPay’s authorised Retailer,
            but must not hold itself out as being entitled to bind DilliPay in
            any way.
          </Typography>
          <Typography
            variant="h4"
            sx={{
              fontSize: "1.8rem",
              fontWeight: "bold",
              marginBottom: 2,
            }}
          >
            2. COMMENCEMENT TERM AND RENEWAL
          </Typography>
          <Typography variant="body1" paragraph>
            The Retailer shall commence business in accordance with the terms
            and conditions of this Retailer Agreement within 15 days from the
            date of signing this Retailer Agreement.
          </Typography>
          <Typography variant="body1" paragraph>
            This Retailer Agreement shall be valid for a period of 9 (nine)
            years unless terminated by DilliPay or Retailer, in accordance with
            clause 13 of this Retailer Agreement. The period of validity of this
            Retailer Agreement shall be referred to as the "Term".
          </Typography>
          <Typography variant="body1" paragraph>
            Upon the expiry of the Term and subject to satisfactory performance
            of the services by the Retailer, Retailer Agreement may be renewed
            at DilliPay’s option, on mutually agreed terms and conditions.
          </Typography>
          <Typography variant="body1" paragraph>
            DilliPay may exercise its right to renew this Retailer Agreement by
            informing one month prior to the completion of Term of this Retailer
            Agreement.
          </Typography>
          <Typography variant="body1" paragraph>
            The Retailer shall ensure that the Retailer Agreement is renewed
            from time to time.
          </Typography>
          <Typography variant="body1" paragraph>
            The Retailer agrees and acknowledges that it shall not do any
            business without a valid Retailer Agreement with DilliPay. Retailer
            agrees and acknowledges that the DilliPay shall not be responsible
            or liable in any manner whatsoever, if the Retailer Agreement is not
            renewed and the Retailer continues business during such period
            whereof there is no valid Agreement between the parties.
          </Typography>
        </Page>
        <Page size="A4" style={styles.page}>
          <section>
            <Typography
              variant="h4"
              sx={{
                fontSize: "1.8rem",
                fontWeight: "bold",
                marginBottom: 2,
              }}
            >
              3. PROVISION OF SERVICES
            </Typography>
            <Typography variant="body1" paragraph>
              During the Term, the Retailer shall render to DilliPay (by through
              such of its Retailer offices, employees, agents, representatives
              and affiliates that Retailer shall designate from time to time)
              services as defined in Annexure-I.
            </Typography>
            <Typography variant="body1" paragraph>
              Not with standing anything to the contrary contained in this
              Retailer Agreement, DilliPay shall have the right to modify, alter
              and amend the list of the Services at any time, including the
              manner in which the Retailer will be required to perform the
              Services. The Retailer shall be bound by all such modifications
              and amendments made by DilliPay.
            </Typography>
          </section>

          <section>
            <Typography
              variant="h4"
              sx={{
                fontSize: "1.8rem",
                fontWeight: "bold",
                marginBottom: 2,
              }}
            >
              4. BUSINESS PLAN AND RETAILERS
            </Typography>

            <Typography variant="body1" paragraph>
              The Parties shall mutually agree upon a Business Plan in relation
              to sourcing of retailers to be appointed by the DilliPay, which
              shall include, inter alia, the minimum number of persons that the
              Retailer shall introduce to DilliPay for the appointment as
              retailers. The Retailers shall agree to introduce retailers as per
              the Business Plan agreed to between Parties. In the event, that
              the Retailers unable to introduce the specified number of persons
              to DilliPay to be appointed as retailers, The Retailer
              acknowledges and agrees that it is solely responsible for issuing
              credit money to the retailers & to withdrawing credit money from
              the retailers in its Territory, and DilliPay is not responsible
              for any error or dispute arising out of such transactions in any
              manner whatsoever.
            </Typography>
          </section>

          <section>
            <Typography
              variant="h4"
              sx={{
                fontSize: "1.8rem",
                fontWeight: "bold",
                marginBottom: 2,
              }}
            >
              5. PAYMENT AND COMMISSION
            </Typography>

            <Typography variant="body1" paragraph sx={{ marginLeft: "20px" }}>
              <strong>a. Deposit:</strong> The Retailer shall deposit a sum of
              INR [……….../=] [……..in words……...] with DilliPay on or before the
              Effective Date. The deposit shall be non–interest bearing and
              shall be refunded at the time of termination of this Retailer
              Agreement, in accordance with the provisions defined in Clause 14
              (Consequences of Termination) of this Agreement. DilliPay may, at
              its sole discretion, reject the deposit on or before the Effective
              Date.
            </Typography>

            <Typography variant="body1" paragraph sx={{ marginLeft: "20px" }}>
              <strong>b. Working Capital:</strong> In addition to the deposit,
              the Retailer shall maintain and deposit with DilliPay, working
              capital to the extent of INR [……….../=] [……..in words……...], which
              shall also be non–interest bearing. The working capital shall be
              utilized solely for enabling transactions on the DilliPay
              platform.
            </Typography>

            <Typography variant="body1" paragraph sx={{ marginLeft: "20px" }}>
              <strong>c. Legitimacy of Funds:</strong> The Retailer agrees and
              acknowledges that DilliPay shall not be responsible or liable in
              any manner whatsoever for the sources of such deposit and/or
              working capital. It is the sole responsibility of the Retailer to
              ensure that such funds are legitimate and in accordance with the
              laws of India.
            </Typography>

            <Typography variant="body1" paragraph sx={{ marginLeft: "20px" }}>
              <strong>d. Mode of Deposit:</strong> All amounts due to DilliPay
              under this Agreement, including the deposit, working capital,
              and/or platform fee, shall be deposited in accordance with the
              instructions provided in Annexure-II. DilliPay may, by prior
              written notice of two (2) business days, modify any of the details
              mentioned in Annexure-II, and the Retailer shall be bound by all
              such modifications.
            </Typography>

            <Typography variant="body1" paragraph sx={{ marginLeft: "20px" }}>
              <strong>e. Restriction on Third-Party Deposits:</strong> The
              Retailer acknowledges and agrees that DilliPay strictly prohibits
              any third-party deposits into its bank accounts via any mode
              whatsoever. In the event that the Retailer indulges in such
              transactions knowingly or unknowingly, the Retailer authorizes
              DilliPay to freeze its account immediately.
            </Typography>

            <Typography variant="body1" paragraph sx={{ marginLeft: "20px" }}>
              <strong>f. Commission / Service Fee:</strong> The Retailer shall
              be entitled to such commission, discount, service fee, or other
              remuneration as may be specified by DilliPay from time to time and
              published on DilliPay’s portal. All amounts payable as commission
              shall be exclusive of applicable taxes (including Goods and
              Services Tax, surcharge, cess, etc.) and subject to deduction of
              tax at source (TDS), if applicable. DilliPay shall debit the
              account of the Retailer to the extent of such taxes.
            </Typography>

            <Typography variant="body1" paragraph sx={{ marginLeft: "20px" }}>
              <strong>g. Accrual and Payment of Commission:</strong>
            </Typography>

            <ul style={{ marginLeft: "40px", marginTop: "-10px" }}>
              <li>
                Commission shall accrue to the Retailer only upon receipt and
                realization by DilliPay of the full payment relating to the
                transactions initiated by the Retailer.
              </li>
              <li>
                Commission so accrued shall be paid to the Retailer on a monthly
                basis, by way of bank transfer or additional credit in the
                working capital.
              </li>
              <li>
                Payments shall be subject to withholding as prescribed under
                applicable law. Subject to the aforesaid, DilliPay assumes no
                responsibility for the tax compliance of the Retailer.
              </li>
            </ul>

            <Typography variant="body1" paragraph sx={{ marginLeft: "20px" }}>
              <strong>h. Chargebacks / Complaints:</strong> Payments made to the
              Retailer shall be subject to deduction of chargebacks, complaints,
              or disputes relating to AEPS transactions, Payment Gateway
              transactions, QR code transactions, deposit/withdrawal
              transactions, or any other transactions whatsoever.
            </Typography>

            <Typography variant="body1" paragraph sx={{ marginLeft: "20px" }}>
              <strong>i. Bank Charges:</strong> The Retailer agrees and
              authorizes DilliPay to impose cash deposit bank charges, which
              shall be deducted from payments made to the Retailer.
            </Typography>

            <Typography variant="body1" paragraph sx={{ marginLeft: "20px" }}>
              <strong>j. Expenses:</strong> All costs and expenses for
              travelling, promotional activities, and other similar
              out-of-pocket expenses incurred in the performance of the Services
              shall be borne solely by the Retailer.
            </Typography>

            <Typography variant="body1" paragraph sx={{ marginLeft: "20px" }}>
              <strong>k. Unauthorized Use:</strong> The Retailer agrees and
              acknowledges that in case of any deviation or misuse relating to
              key salt or any unauthorized use of the DilliPay platform, the
              Retailer shall be solely responsible and liable. DilliPay is
              authorized to immediately deactivate the Retailer’s account
              without prior notice and shall not be responsible for any
              consequences arising therefrom.
            </Typography>

            <Typography variant="body1" paragraph sx={{ marginLeft: "20px" }}>
              <strong>l. Complaints from Authorities:</strong> The Retailer
              agrees and authorizes DilliPay to freeze its account in the event
              DilliPay receives any complaint from any statutory, non-statutory
              authority, government department, or agency. Further, the Retailer
              authorizes DilliPay to withdraw the disputed amount along with any
              anticipated penalty from such frozen account.
            </Typography>

            <Typography variant="body1" paragraph sx={{ marginLeft: "20px" }}>
              <strong>m. Deposit of Sales / Receipts:</strong> The Retailer
              agrees and acknowledges that all sales/receipts relating to
              DilliPay services shall be immediately deposited or transferred
              into DilliPay’s designated bank accounts. The Retailer shall
              thereafter receive working limits in the portal against such
              deposits.
              <br />
              <br />
              The Retailer shall inform DilliPay in the predefined format
              regarding deposits made. In case of failure to inform within seven
              (7) calendar days, the deposited amount shall be liable to
              forfeiture by DilliPay. The Retailer may deposit such cash
              personally or via its employee, agent, or any duly authorized
              person into DilliPay’s designated bank accounts.
            </Typography>
          </section>

          <section>
            <Typography
              variant="h4"
              sx={{
                fontSize: "1.8rem",
                fontWeight: "bold",
                marginBottom: 2,
              }}
            >
              6. OPERATIONS OF THE RETAILER
            </Typography>

            <Typography variant="body1" paragraph>
              The <strong>Retailer</strong> shall operate and provide the
              Services from its independent offices equipped with the necessary
              infrastructure,devices and workforce required to provide the
              Services. The Retailer shall provide a prior written intimation to
              <strong>DilliPay</strong> of any changes in the location of such
              outlet(s).
            </Typography>
            <Typography variant="body1" paragraph>
              <strong>DilliPay</strong> , at its discretion, may provide
              guidance to the Retailer in relation to signage, branding, display
              materials, investment in technology systems, basic accounting
              practices, customer handling, and business procedures. The
              Retailer shall be bound to comply with such guidance as may be
              prescribed by DilliPay from time to time.
            </Typography>
            <Typography variant="body1" paragraph>
              <strong>MARKET INTELLIGENCE</strong> : The Retailer shall develop
              adequate and relevant market intelligence in relation to the
              Territory and shall inform DilliPay from time to time about the
              activities of other persons/companies engaged in a similar
              business.
            </Typography>
          </section>
          <section>
            <Typography
              variant="h4"
              sx={{
                fontSize: "1.8rem",
                fontWeight: "bold",
                marginBottom: 2,
              }}
            >
              7. MARKET INTELLIGENCE
            </Typography>

            <Typography variant="body1" paragraph>
              The Retailer shall develop adequate and relevant market
              intelligence in relation to the Territory and shall inform
              DilliPay from time to time about the activities of other
              persons/companies engaged in a similar business.
            </Typography>
          </section>
        </Page>
        <section>
          <Typography
            variant="h4"
            sx={{
              fontSize: "1.8rem",
              fontWeight: "bold",
              marginBottom: 2,
            }}
          >
            8. EMPLOYEES OF RETAILER
          </Typography>

          <Typography variant="body1" paragraph>
            The Retailer shall engage the minimum number of personnel as
            specified by the DilliPay and such other additional personnel as may
            be required to effectively provide the Services. The Retailer shall
            ensure that all personnel employed in the provision of the Services
            shall be adequately trained and shall comply with the Term of this
            Retailer Agreement. The Retailer agrees and acknowledges that it
            shall do proper due diligence and background check of all such
            personnel.
          </Typography>
          <Typography variant="body1" paragraph>
            The Retailer shall be liable and responsible for any data theft or
            misuse of any data related to clients of DilliPay from its office.
          </Typography>
          <Typography variant="body1" paragraph>
            The Retailer agrees and acknowledges that DilliPay will not have any
            obligations, liability or responsibility whatsoever to supervise or
            manage the Retailer's employees, agents or independent contractors.
          </Typography>
        </section>
        <Page size="A4" style={styles.page}>
          <section>
            <Typography
              variant="h4"
              sx={{
                fontSize: "1.8rem",
                fontWeight: "bold",
                marginBottom: 2,
              }}
            >
              8. LICENSE AND INTELLECTUAL PROPERTY
            </Typography>

            {/* Grant of License */}
            <Typography variant="body1" paragraph sx={{ marginLeft: "20px" }}>
              <strong>a. Grant of License:</strong> DilliPay Technologies
              Limited (“DilliPay”) hereby grants to the Retailer a limited,
              non-exclusive, non-transferable, non-assignable, revocable, and
              royalty-free license to use the DilliPay software, application
              programming interfaces (APIs), portals, dashboards, and other
              technology platforms (collectively, the “Software”) solely for the
              purpose of providing the Services contemplated under this Retailer
              Agreement. Such license may be revoked, suspended, or modified by
              DilliPay at its sole discretion, without liability.
            </Typography>

            {/* Restrictions on Use */}
            <Typography variant="body1" paragraph sx={{ marginLeft: "20px" }}>
              <strong>b. Restrictions on Use:</strong> The Retailer shall not:
            </Typography>
            <ul
              style={{
                marginLeft: "60px",
                marginTop: "-10px",
                marginBottom: "20px",
              }}
            >
              <li>
                Distribute, sub-license, sell, lease, assign, transfer, pledge,
                or otherwise make available the Software, related technical
                documentation, or any portion thereof to any third party in any
                form.
              </li>
              <li>
                Modify, adapt, translate, reverse engineer, decompile,
                disassemble, or create derivative works based on the Software.
              </li>
              <li>
                Use the Software for any purpose other than as expressly
                permitted under this Agreement.
              </li>
            </ul>

            {/* Third-Party Software */}
            <Typography variant="body1" paragraph sx={{ marginLeft: "20px" }}>
              <strong>c. Third-Party Software:</strong> The Retailer may use
              third-party software in conjunction with the Services only with
              the prior written approval of DilliPay. The Retailer shall ensure
              that any such third-party software is duly licensed, valid, and
              lawfully installed. DilliPay shall not be responsible for any
              liability arising from the Retailer’s unauthorized or unlawful use
              of third-party software.
            </Typography>

            {/* Ownership of Intellectual Property */}
            <Typography variant="body1" paragraph sx={{ marginLeft: "20px" }}>
              <strong>d. Ownership of Intellectual Property:</strong> DilliPay
              shall retain and continue to own all rights, title, and interest
              in and to its intellectual property, including without limitation:
            </Typography>
            <ul
              style={{
                marginLeft: "60px",
                marginTop: "-10px",
                marginBottom: "20px",
              }}
            >
              <li>
                The Software, platform, APIs, documentation, and related
                technology;
              </li>
              <li>
                DilliPay’s trade name, trademark, service marks, logo, branding,
                and promotional/marketing materials; and
              </li>
              <li>
                Any enhancements, updates, modifications, or derivative works
                thereof, whether created by or for DilliPay or suggested by the
                Retailer.
              </li>
            </ul>

            <Typography variant="body1" paragraph sx={{ marginLeft: "40px" }}>
              The Retailer acknowledges and agrees that:
            </Typography>
            <ul
              style={{
                marginLeft: "60px",
                marginTop: "-10px",
                marginBottom: "20px",
              }}
            >
              <li>
                Nothing in this Agreement shall be construed as a transfer of
                ownership of any intellectual property rights to the Retailer;
              </li>
              <li>
                DilliPay retains the unrestricted right to license its
                intellectual property to any third party, including competitors
                of the Retailer; and
              </li>
              <li>
                Any and all goodwill arising from the Retailer’s use of
                DilliPay’s intellectual property shall vest exclusively with
                DilliPay, without any obligation of compensation to the
                Retailer.
              </li>
            </ul>

            {/* Compliance with Applicable Law */}
            <Typography variant="body1" paragraph sx={{ marginLeft: "20px" }}>
              <strong>e. Compliance with Applicable Law:</strong> The Retailer
              shall use the Software and DilliPay’s intellectual property
              strictly in accordance with the applicable laws of India,
              including but not limited to:
            </Typography>
            <ul
              style={{
                marginLeft: "60px",
                marginTop: "-10px",
                marginBottom: "20px",
              }}
            >
              <li>
                The <strong>Information Technology Act, 2000</strong> and rules
                made thereunder;
              </li>
              <li>
                The{" "}
                <strong>Copyright Act, 1957, the Trade Marks Act, 1999,</strong>{" "}
                and other applicable intellectual property laws;
              </li>
              <li>
                The{" "}
                <strong>Prevention of Money Laundering Act, 2002 (PMLA)</strong>{" "}
                and applicable RBI guidelines; and
              </li>
              <li>
                Any data protection, cyber security, and consumer protection
                regulations as notified by competent authorities from time to
                time.
              </li>
            </ul>

            {/* Prohibited Use */}
            <Typography variant="body1" paragraph sx={{ marginLeft: "20px" }}>
              <strong>f. Prohibited Use Without Authorization:</strong> The
              Retailer shall not use the Software, APIs, or any other platform
              of DilliPay in any manner whatsoever without the prior written
              authorization of DilliPay. Unauthorized use shall entitle DilliPay
              to immediately deactivate the Retailer’s access, terminate this
              Agreement, and pursue appropriate legal remedies.
            </Typography>
          </section>

          <section>
            <Typography
              variant="h4"
              sx={{
                fontSize: "1.8rem",
                fontWeight: "bold",
                marginBottom: 2,
              }}
            >
              9. CONFIDENTIALITY
            </Typography>

            <Typography variant="body1" paragraph>
              The Parties undertake to retain in strict confidence the terms of
              this Retailer Agreement and all non-public information,
              technology, materials, trade secrets, business strategies,
              financial data, and know-how of the other Party disclosed to or
              acquired by the receiving Party in connection with this Agreement,
              which is either designated as confidential or, by the nature of
              its disclosure, ought in good faith to be treated as confidential,
              provided that such information may be disclosed only to the
              receiving Party’s directors, officers, employees, legal advisors,
              auditors, or financial consultants in the ordinary course of
              business on a strict need-to-know basis. The Retailer further
              acknowledges and agrees that DilliPay has a legal and fiduciary
              responsibility to safeguard customer information, including KYC
              documents, Aadhaar details, PAN, bank account information,
              transaction data, and other personal details, and accordingly
              undertakes to maintain such information in the strictest
              confidence, not to copy, misuse, disclose, or allow unauthorized
              access to such information, and to comply with the provisions of
              the Information Technology Act, 2000, the Information Technology
              (Reasonable Security Practices and Procedures and Sensitive
              Personal Data or Information) Rules, 2011, the Digital Personal
              Data Protection Act, 2023, and applicable RBI/UIDAI guidelines.
              Confidential Information shall not include information which is or
              becomes publicly available otherwise than by breach of this
              clause, is lawfully obtained from a third party without
              restriction, is independently developed without reference to the
              Confidential Information of the disclosing Party, or is required
              to be disclosed under applicable law, regulation, or order of a
              competent authority, subject to prior notice to the disclosing
              Party where legally permissible. The obligations under this clause
              shall survive the expiry or termination of this Agreement for a
              period of five (5) years, or such longer period as may be required
              under applicable law with respect to customer and transaction
              data.
            </Typography>
          </section>
        </Page>
        <Page size="A4" style={styles.page}>
          <section>
            <Typography
              variant="h4"
              sx={{
                fontSize: "1.8rem",
                fontWeight: "bold",
                marginBottom: 2,
              }}
            >
              10. COMPETITION AND SOLICIT
            </Typography>

            <Typography variant="body1" paragraph>
              The Retailer agrees and undertakes that during the Term of
              Retailer Agreement and for a period of one year thereafter, it
              shall not, directly, through its employees, affiliates or
              relatives or in a firm where the Retailer or any relative or
              nominee of the Retailer is a partner or in any company where the
              Retailer or any relative or nominee of the Retailer is a director
              or shareholder,
              <br />
              1.) be appointed as a Retailer for any other person or legal
              entity which is carrying on a business similar or in competition
              with any business carried by DilliPay at the relevant time,
              whether in India or abroad, or
              <br />
              2.) engage in any business that is similar to or in competition
              with any business carried on by the DilliPay at the relevant time.
            </Typography>
            <Typography variant="body1" paragraph>
              During the Term of Retailer Agreement, the Retailer shall not
              either directly or indirectly solicit any employee of DilliPay for
              employment, induce or attempt to induce any such employee to
              terminate or breach his or her employment agreement with DilliPay,
              or hire any such employee or associate with any such employee,
              either during the course of their employment with DilliPay or
              after the termination of their employment with the DilliPay.
            </Typography>
            <Typography variant="body1" paragraph>
              During the Term of this Retailer Agreement, the Retailer shall not
              either directly or indirectly, solicit, cause in any part or
              knowingly encourage any existing or potential clients or customers
              of DilliPay to cease doing business or not to do business, in
              whole or in part of with DilliPay, or solicit, cause in any part
              or knowingly encourage any existing or potential clients or
              customers of DilliPay to do business with any person other then
              DilliPay, or associate with any prospective clients or customers
              while they continue to be clients or customers of DilliPay.
            </Typography>
          </section>

          <section>
            <Typography
              variant="h4"
              sx={{
                fontSize: "1.8rem",
                fontWeight: "bold",
                marginBottom: 2,
              }}
            >
              11. EXCLUSIVITY
            </Typography>

            <Typography variant="body1" paragraph>
              The Retailer shall only market and promote Services of DilliPay,
              as authorized by the DilliPay.
            </Typography>
          </section>

          <section>
            <Typography
              variant="h4"
              sx={{
                fontSize: "1.8rem",
                fontWeight: "bold",
                marginBottom: 2,
              }}
            >
              12. TERMINATION OF AGREEMENT
            </Typography>

            <Typography variant="body1" paragraph sx={{ marginLeft: "20px" }}>
              DilliPay may terminate this Retailer Agreement with immediate
              effect under any of the following circumstances:
            </Typography>

            <ul
              style={{
                marginLeft: "60px",
                marginTop: "-10px",
                marginBottom: "20px",
              }}
            >
              <li>
                <strong>a.</strong> If, in the opinion of DilliPay, the Retailer
                is not a fit or suitable person to perform the Services under
                the provisions of this Retailer Agreement.
              </li>
              <li>
                <strong>b.</strong> If the Retailer fails to deposit the
                proceeds of sales or receipts collected by the Retailer or its
                sub-retailers to DilliPay on a daily and continuous basis.
              </li>
              <li>
                <strong>c.</strong> If the Retailer becomes the subject of a
                voluntary petition in bankruptcy or any other proceedings
                relating to insolvency, liquidation, or composition for the
                benefit of creditors.
              </li>
              <li>
                <strong>d.</strong> If the Retailer fails to comply with any
                directions or instructions issued by DilliPay under the
                provisions of this Retailer Agreement.
              </li>
              <li>
                <strong>e.</strong> Not with standing anything to the contrary
                herein, DilliPay may terminate this Retailer Agreement without
                notice.
              </li>
              <li>
                <strong>f.</strong> Retailer may terminate this Retailer
                Agreement with written notice of 60 (sixty) days to DilliPay.
              </li>
            </ul>
          </section>
          <section>
            <Typography
              variant="h4"
              sx={{
                fontSize: "1.8rem",
                fontWeight: "bold",
                marginBottom: 2,
              }}
            >
              13. CONSEQUENCE OF TERMINATION
            </Typography>

            <Typography variant="body1" paragraph sx={{ marginLeft: "20px" }}>
              Upon termination of this Retailer Agreement for any reason as
              stated in clause 13 above, the Retailer shall Upon termination of
              this Retailer Agreement for any reason as stated in clause 13
              above, the Retailer shall
            </Typography>
            <ul
              style={{
                marginLeft: "60px",
                marginTop: "-10px",
                marginBottom: "20px",
              }}
            >
              <li>
                Immediately discontinue and cease the use of DilliPay’s
                trademarks, logos, intellectual property, and Software, and
                promptly hand over all copies or documents containing such
                intellectual property to DilliPay.
              </li>
              <li>
                Immediately return to DilliPay all confidential information,
                originals, and copies of any materials provided to the Retailer
                under this Agreement or in the course of providing the Services.
              </li>
              <li>
                Immediately provide DilliPay with remote access to disable any
                Software installed by DilliPay at the Retailer’s premises or
                systems.
              </li>
              <li>
                Immediately remove all signboards, banners, glowboards, or any
                other promotional materials bearing DilliPay’s name, logo, or
                indicating any association with DilliPay.
              </li>
              <li>
                Immediately cease to promote, market, or advertise DilliPay or
                any of its products and services.
              </li>
              <li>
                Settle and clear all outstanding dues payable to DilliPay within
                seven (7) days from the date of termination.
              </li>
            </ul>
          </section>

          <section>
            <Typography
              variant="h4"
              sx={{
                fontSize: "1.8rem",
                fontWeight: "bold",
                marginBottom: 2,
              }}
            >
              14. INDEMNITY, LIABILITY AND COMPLIANCE
            </Typography>

            <Typography variant="body1" paragraph>
              <strong>Indemnity:</strong> The Retailer shall indemnify, defend,
              and hold harmless DilliPay Technologies Limited (“DilliPay”), its
              financial partners, affiliates, officers, directors, employees,
              successors, and assigns, from and against any and all customer
              claims, actions, demands, litigations, suits, proceedings, losses,
              expenses, costs, damages, charges, or penalties arising out of or
              in connection with:
            </Typography>

            <ul>
              <li>Wilful misconduct or negligence of the Retailer;</li>
              <li>Fraud or misrepresentation by the Retailer;</li>
              <li>Breach of applicable laws, regulations, or guidelines; or</li>
              <li>
                Breach of any terms or conditions of this Retailer Agreement
                directly attributable to the Retailer.
              </li>
            </ul>

            <Typography variant="body1" paragraph>
              <strong>Limitation of Liability:</strong> Notwithstanding anything
              contained herein, DilliPay shall not be liable to the Retailer for
              any incidental, indirect, special, punitive, or consequential
              damages, including but not limited to loss of revenue, profits,
              goodwill, or business opportunities, even if advised of the
              possibility of such damages.
            </Typography>

            <Typography variant="body1" paragraph>
              <strong>Anti-Money Laundering (AML) Compliance:</strong> The
              Retailer shall ensure that the DilliPay platform or services are
              not used for money laundering and shall comply with all applicable
              AML and counter-terrorism financing laws, including but not
              limited to the Prevention of Money Laundering Act, 2002, and the
              rules, regulations, and guidelines issued thereunder by competent
              authorities.
            </Typography>

            <Typography variant="body1" paragraph>
              <strong>Prohibited Transactions:</strong> The Retailer undertakes
              not to permit, process, or entertain any transfer of money or
              transaction through the DilliPay platform or services in relation
              to:
            </Typography>

            <ul>
              <li>
                Narcotic drugs, psychotropic substances, or illegal
                pharmaceuticals;
              </li>
              <li>Arms, ammunition, explosives, or weapons;</li>
              <li>Terrorism financing or terrorist activities;</li>
              <li>Money laundering or illegal fund transfers;</li>
              <li>Counterfeiting of currency, securities, or goods;</li>
              <li>
                Unauthorized cross-border transactions in violation of the
                Foreign Exchange Management Act, 1999 (FEMA);
              </li>
              <li>Any unlawful purpose or illegal activity; or</li>
              <li>
                Any article, object, or material prohibited under the laws of
                India or by the Government of India.
              </li>
            </ul>

            <Typography variant="body1" paragraph>
              <strong>Prohibited Misuse of Platform:</strong> The Retailer
              undertakes that it shall not use or misuse the DilliPay technology
              platform for:
            </Typography>

            <ul>
              <li>
                Splitting a single transaction into multiple transactions with a
                view to earn additional commission;
              </li>
              <li>
                Engaging in financial transactions resulting in circular
                movement or round-tripping of funds;
              </li>
              <li>
                Selling, disclosing, or sharing any customer information
                (including KYC details and contact information) with third
                parties; or
              </li>
              <li>
                Making unauthorized copies (digital or physical) of any customer
                forms, documents, photographs, or identification devices,
                whether used or unused.
              </li>
            </ul>

            <Typography variant="body1" paragraph>
              <strong>Survival:</strong> The obligations under this Clause shall
              survive the expiry or termination of this Retailer Agreement and
              shall remain valid in respect of any claims, liabilities, or
              disputes arising during the subsistence of this Agreement.
            </Typography>

            <Typography variant="body1" paragraph>
              <strong>
                Retention of KYC and Related Documentation – Legal and
                Regulatory Compliance Clause:
              </strong>{" "}
              Pursuant to applicable provisions of Indian law and in strict
              compliance with directions, notifications, and circulars issued by
              competent statutory and regulatory authorities—including but not
              limited to the Ministry of Finance, Reserve Bank of India (RBI),
              Securities and Exchange Board of India (SEBI), Insurance
              Regulatory and Development Authority of India (IRDAI), Food Safety
              and Standards Authority of India (FSSAI), and any other
              sector-specific regulators—all retailers, distributors, agents,
              intermediaries, and associated business entities are legally
              obligated to collect, maintain, and preserve Know Your Customer
              (KYC) records and all related documents pertaining to any
              consumer, client, retailer, distributor, supplier, or other
              related parties.
            </Typography>

            <Typography variant="body1" paragraph>
              These records shall include, but are not limited to:
            </Typography>

            <ul>
              <li>Identity and address proofs;</li>
              <li>PAN and/or Aadhaar information (as per applicable norms);</li>
              <li>Business registration documents;</li>
              <li>Transactional history;</li>
              <li>Communication logs and agreements; and</li>
              <li>
                Any additional documentation required under statutory
                obligations or internal due diligence procedures.
              </li>
            </ul>

            <Typography variant="body1" paragraph>
              In accordance with the record-keeping obligations under:
            </Typography>

            <ul>
              <li>
                Section 12 of the Prevention of Money Laundering Act, 2002 and
                Rule 3 of the PML Rules, 2005;
              </li>
              <li>Section 44AA and Rule 6F of the Income Tax Rules, 1962;</li>
              <li>Sections 128 and 129 of the Companies Act, 2013;</li>
              <li>
                Relevant RBI/SEBI/IRDAI/FSSAI circulars and guidelines; and
              </li>
              <li>
                The Digital Personal Data Protection Act, 2023 and associated
                rules concerning data retention and security.
              </li>
            </ul>

            <Typography variant="body1" paragraph>
              All such records must be retained for a minimum statutory period
              of ten (10) years from the date of:
            </Typography>

            <ul>
              <li>The last transaction;</li>
              <li>Termination of the business relationship; or</li>
              <li>Closure of the account or engagement—whichever is later.</li>
            </ul>

            <Typography variant="body1" paragraph>
              Furthermore, entities must ensure that:
              <ul>
                <li>
                  Records are <strong>stored securely </strong> in both physical
                  and electronic forms;
                </li>
                <li>
                  <strong> Access is strictly controlled </strong>and limited to
                  authorized personnel;
                </li>
                <li>
                  Adequate{" "}
                  <strong>data protection and cybersecurity measures </strong>{" "}
                  are in place to prevent unauthorized access, alteration, or
                  disclosure; and
                </li>
                <li>
                  All actions are in accordance with the provisions of the
                  Digital Personal Data Protection (DPDP) Act and other
                  applicable privacy laws.
                </li>
              </ul>
            </Typography>

            <Typography variant="body1" paragraph>
              Failure to comply with the above-stated obligations may attract
              <strong> penal provisions</strong> under the respective statutes,
              including but not limited to{" "}
              <strong>
                monetary fines, cancellation of licenses or registrations,
                prosecution, and other enforcement actions
              </strong>{" "}
              as deemed fit by the concerned authority.
            </Typography>
          </section>
        </Page>
        <Page size="A4" style={styles.page}>
          <section>
            <Typography
              variant="h4"
              sx={{
                fontSize: "1.8rem",
                fontWeight: "bold",
                marginBottom: 2,
              }}
            >
              16. RELATIONSHIP BETWEEN THE PARTIES
            </Typography>

            <Typography variant="body1" paragraph>
              The Services rendered by the Retailer under this Retailer
              Agreement shall be provided as an independent contractor to
              DilliPay, and nothing in this Retailer Agreement creates or shall
              be deemed to create the relationship of partners, joint venture,
              employees, or principal-agent between the Parties.
            </Typography>
          </section>
        </Page>
        {/* Section 17: RECORDS AND AUDIT */}
        <Page size="A4" style={styles.page}>
          <section>
            <Typography
              variant="h4"
              sx={{
                fontSize: "1.8rem",
                fontWeight: "bold",
                marginBottom: 2,
              }}
            >
              17. RECORDS AND AUDIT
            </Typography>

            <Typography variant="body1" paragraph>
              The Retailer shall maintain all statutory books as may be required
              from time to time to be maintained under the all applicable laws.
            </Typography>
            <Typography variant="body1" paragraph>
              The Retailer shall permit the DilliPay, to enter into and inspect
              all books of accounts, record and materials in relation to the
              business operations related to this Retailer Agreement during
              normal business hours.
            </Typography>
            <Typography variant="body1" paragraph>
              The Retailer shall ensure that KYC details/minimum details (as
              applicable) provided by the Customers be verified and carry out
              proper due diligence in the manner as instructed by the company in
              this regard. The Retailer shall be solely responsible for the
              verification process of KYC details/minimum details of the
              Customers and the Retailer/Aggregator hereby agrees that it shall
              be liable to indemnify the company in case of any losses or claims
              or penalties arising out of defective KYC verification process of
              the Customers for any transaction or any process regarding the
              platform or services of the company/ DilliPay.
            </Typography>
            <Typography variant="body1" paragraph>
              During the Term and at any time within sixty days after the
              termination of this Retailer Agreement, DilliPay, through its
              employees, representatives or agents, may, at its expense, carry
              out an audit to determine whether the audit has properly completed
              its obligations under this Retailer Agreement.
            </Typography>
          </section>

          {/* Section 18: AMENDMENT */}

          <section>
            <Typography
              variant="h4"
              sx={{
                fontSize: "1.8rem",
                fontWeight: "bold",
                marginBottom: 2,
              }}
            >
              18. AMENDMENT
            </Typography>

            <Typography variant="body1" paragraph>
              No changes, alterations, modifications, or additions to this
              Retailer Agreement shall be valid unless made in writing and
              executed by both parties.
            </Typography>
          </section>

          {/* Section 19: ASSIGNMENT */}

          <section>
            <Typography
              variant="h4"
              sx={{
                fontSize: "1.8rem",
                fontWeight: "bold",
                marginBottom: 2,
              }}
            >
              19. ASSIGNMENT
            </Typography>

            <Typography variant="body1" paragraph>
              The Retailer shall not assign, sub-let, or subcontract any of its
              obligations under this Retailer Agreement to any third party
              unless it obtains prior written permission/consent from the
              DilliPay. In any event, any assignment or transfer shall not
              operate to relieve the assigning party of any of its obligations
              hereunder, nor will any such assignment impose any obligation on
              the assignee except in the case of express written assumption by
              the assignee.
            </Typography>
            <Typography variant="body1" paragraph>
              No such assignment under this clause shall relieve the Retailer of
              any obligations or liabilities incurred prior to the assignment
              unless mutually agreed to in writing.
            </Typography>
          </section>

          <section>
            <Typography
              variant="h4"
              sx={{
                fontSize: "1.8rem",
                fontWeight: "bold",
                marginBottom: 2,
              }}
            >
              20. COMMUNICATION
            </Typography>

            <Typography variant="body1" paragraph>
              The Retailer hereby agrees that being a DilliPay Retailer,
              DilliPay may communicate include communications including but not
              limited to voice, email, SMS, digital video, and / or any mode of
              innovative communication method, as deemed fit and proper by the
              company/ Dillipay.
            </Typography>
          </section>
          <section>
            <Typography
              variant="h4"
              sx={{
                fontSize: "1.8rem",
                fontWeight: "bold",
                marginBottom: 2,
              }}
            >
              21. CHARGEBACK
            </Typography>

            <Typography variant="body1" paragraph>
              Upon receipt of a Chargeback notification from the Acquirer or the
              Issuer, Dillipay shall forthwith notify the Client. The Client
              shall have the right to submit to Dillipay, within five (5) days
              from such notification (or within such other period as may be
              specified by the Acquirer), documentary evidence and information
              (“Chargeback Documents”) substantiating the completion of the
              underlying transaction and/or the delivery of goods or services to
              the Customer. In the event the Client fails to furnish the
              Chargeback Documents within the stipulated period, or if the
              Issuer, at its sole discretion, deems the documents insufficient,
              the Issuer shall be entitled to instruct the Acquirer or Dillipay
              to reverse the debit and credit the Chargeback Amount to the
              Customer’s payment instrument. If Dillipay is charged the
              Chargeback Amount by the Acquirer or the Issuer, Dillipay shall be
              entitled to recover such Chargeback Amount from the Client by
              deducting the same from any subsequent settlement amounts due to
              the Client. In the event the available settlement amounts are
              insufficient to cover the Chargeback Amount, Dillipay shall be
              entitled to issue a debit note to the Client, and the Client shall
              reimburse the Chargeback Amount within thirty (30) days from
              receipt of such debit note. Furthermore, upon issuance of a
              termination notice under this Agreement, Dillipay shall be
              entitled to withhold, from each settlement made during the notice
              period, a sum calculated based on the stipulated percentage—being
              the proportion of the total Chargeback Amounts to the aggregate
              Transaction Amounts settled during the term of this Agreement—for
              a period of one hundred and twenty (120) days from the date of
              termination ("Withholding Term"). The withheld sums shall be
              utilized solely for settlement of post-termination Chargebacks,
              and any unutilized balance shall be refunded to the Client
              forthwith upon expiry of the Withholding Term.
            </Typography>
          </section>
          {/* Section 21: LITIGATION */}

          <section>
            <Typography
              variant="h4"
              sx={{
                fontSize: "1.8rem",
                fontWeight: "bold",
                marginBottom: 2,
              }}
            >
              21. LITIGATION
            </Typography>

            <Typography variant="body1" paragraph>
              No claim, action, suit, arbitration, or other legal proceeding
              shall be initiated or maintained by the Retailer against DilliPay
              Technologies Limited (“DilliPay”) in respect of any matter,
              dispute, It is expressly agreed that this Retailer Agreement, and
              any rights and obligations arising hereunder, shall be governed by
              and construed in accordance with the laws of India, including but
              not limited to the Indian Contract Act, 1872, the Information
              Technology Act, 2000, the Arbitration and Conciliation Act, 1996
              (as amended), and other applicable laws in force from time to
              time. The Parties further agree that any dispute which cannot be
              resolved amicably within the aforesaid notice period shall,
              subject to the provisions of this Agreement, fall exclusively
              within the jurisdiction of the competent courts at Delhi, India,
              to the exclusion of all other courts, tribunals, or fora, whether
              local, national, or international, and the Parties hereby
              irrevocably submit themselves to such jurisdiction.
            </Typography>
          </section>
          <Box sx={{ padding: 3, maxWidth: "lg", margin: "0 auto" }}>
            {/* Section 21: RESTRICTION ON LIABILITY */}
            <Typography
              variant="h4"
              sx={{
                fontSize: "1.8rem",
                fontWeight: "bold",
                marginBottom: 2,
                color: "#2c3e50",
                borderBottom: "2px solid #3498db",
                paddingBottom: 1,
              }}
            >
              21. RESTRICTION ON LIABILITY
            </Typography>

            <Typography variant="body1" paragraph sx={{ lineHeight: 1.6 }}>
              DilliPay shall not be liable to the Client for the following:
            </Typography>

            <List sx={{ listStyleType: "disc", pl: 4 }} component="ul">
              <ListItem sx={{ display: "list-item", py: 0.5 }}>
                <ListItemText primary="Any loss of profit, goodwill, business, business opportunity, anticipated savings, or any special, indirect, or consequential damages." />
              </ListItem>
              <ListItem sx={{ display: "list-item", py: 0.5 }}>
                <ListItemText primary="Any loss that is an indirect or secondary consequence of any act or omission of the party." />
              </ListItem>
              <ListItem sx={{ display: "list-item", py: 0.5 }}>
                <ListItemText primary="The total liability of DilliPay towards the Client shall, in all circumstances, be limited to the value of the specific transaction under dispute." />
              </ListItem>
              <ListItem sx={{ display: "list-item", py: 0.5 }}>
                <ListItemText primary="DilliPay shall have no obligations to the Client and/or its customers other than putting the transaction value back into the Client's wallet, in case of any loss or damage arising out of or in connection with this Agreement, or due to any breach or non-performance of undertakings, warranties, covenants, declarations, or obligations under this Agreement, or otherwise in contract, tort (including negligence or breach of statutory duty), misrepresentation, or otherwise." />
              </ListItem>
            </List>

            <Divider sx={{ my: 4 }} />

            {/* Section 22: RETAILER'S DECLARATION */}
            <Typography
              variant="h4"
              sx={{
                fontSize: "1.8rem",
                fontWeight: "bold",
                marginTop: 4,
                marginBottom: 2,
                color: "#2c3e50",
                borderBottom: "2px solid #3498db",
                paddingBottom: 1,
              }}
            >
              22. RETAILER'S / LEGAL DECLARATION FOR RESPONSIBLE USE OF PAYMENT
              GATEWAY & UPI/QR COLLECTION PROVIDED BY DILLIPAY
            </Typography>

            <Typography variant="body1" paragraph sx={{ lineHeight: 1.6 }}>
              This Declaration is made and executed on this ___ day of
              _________, 2025, by [_______________Legal Name], a company/firm
              duly incorporated and existing under the laws of [New Delhi],
              having its registered office at [Complete Registered Address],
              bearing business registration number [CIN/LLPIN/Business ID]
              (hereinafter referred to as the "Retailer/User" or "Declarant").
            </Typography>

            <Typography variant="body1" paragraph sx={{ lineHeight: 1.6 }}>
              IN FAVOUR OF: DilliPay Technologies Limited, having its registered
              office at Plot No.-5, 2nd Floor, Pocket-5, Sector-24, Rohini,
              Delhi-110085 (hereinafter referred to as "DilliPay" or the
              "Service Provider").
            </Typography>

            <Typography variant="body1" paragraph sx={{ lineHeight: 1.6 }}>
              WHEREAS:
            </Typography>

            <List sx={{ listStyleType: "disc", pl: 4 }} component="ul">
              <ListItem sx={{ display: "list-item", py: 0.5 }}>
                <ListItemText primary="The Retailer/User intends to avail Payment Gateway & UPI/QR collection services from DilliPay to enable digital payment collection from its customers." />
              </ListItem>
              <ListItem sx={{ display: "list-item", py: 0.5 }}>
                <ListItemText primary="DilliPay has agreed to provide such services, subject to applicable laws, internal risk policies, and commercial terms." />
              </ListItem>
              <ListItem sx={{ display: "list-item", py: 0.5 }}>
                <ListItemText primary="The Retailer/User is required to make the following declarations and undertakings as a condition to avail and continue using DilliPay's services." />
              </ListItem>
            </List>

            {/* PURPOSE OF USE */}
            <Typography
              variant="h6"
              sx={{ fontWeight: "bold", mt: 3, color: "#34495e" }}
            >
              PURPOSE OF USE
            </Typography>

            <List sx={{ listStyleType: "disc", pl: 4 }} component="ul">
              <ListItem sx={{ display: "list-item", py: 0.5 }}>
                <ListItemText primary="The Retailer/User shall use DilliPay's Payment Gateway & UPI/QR services exclusively for processing payments for actual, lawful, and verifiable transactions." />
              </ListItem>
              <ListItem sx={{ display: "list-item", py: 0.5 }}>
                <ListItemText primary="The Retailer/User shall not use these services for unrelated, restricted, or high-risk activities without prior written consent from DilliPay." />
              </ListItem>
            </List>

            {/* TERMS & CONDITIONS */}
            <Typography
              variant="h6"
              sx={{ fontWeight: "bold", mt: 3, color: "#34495e" }}
            >
              TERMS & CONDITIONS
            </Typography>

            <Typography
              variant="body1"
              paragraph
              sx={{ lineHeight: 1.6, mt: 2 }}
            >
              <strong>1. Mandatory KYC Verification:</strong>
            </Typography>
            <List sx={{ listStyleType: "disc", pl: 4 }} component="ul">
              <ListItem sx={{ display: "list-item", py: 0.5 }}>
                <ListItemText primary="Retailers must collect full KYC details of customers, including name, partial card number (last 4 digits), and valid government ID (Aadhaar, PAN, Passport, etc.)." />
              </ListItem>
              <ListItem sx={{ display: "list-item", py: 0.5 }}>
                <ListItemText primary="ID proof must be verified against the payment instrument." />
              </ListItem>
            </List>

            <Typography
              variant="body1"
              paragraph
              sx={{ lineHeight: 1.6, mt: 2 }}
            >
              <strong>2. Restriction on Third-Party Payments:</strong>
            </Typography>
            <List sx={{ listStyleType: "disc", pl: 4 }} component="ul">
              <ListItem sx={{ display: "list-item", py: 0.5 }}>
                <ListItemText primary="Payments shall only be accepted from the actual cardholder or account holder." />
              </ListItem>
              <ListItem sx={{ display: "list-item", py: 0.5 }}>
                <ListItemText primary="Payments on behalf of third parties are strictly prohibited." />
              </ListItem>
              <ListItem sx={{ display: "list-item", py: 0.5 }}>
                <ListItemText primary="Registered mobile numbers linked to ID must be used for validation." />
              </ListItem>
            </List>

            <Typography
              variant="body1"
              paragraph
              sx={{ lineHeight: 1.6, mt: 2 }}
            >
              <strong>3. Record Maintenance & Customer Signature:</strong>
            </Typography>
            <List sx={{ listStyleType: "disc", pl: 4 }} component="ul">
              <ListItem sx={{ display: "list-item", py: 0.5 }}>
                <ListItemText primary="Maintain customer ID proof and transaction authorization records." />
              </ListItem>
              <ListItem sx={{ display: "list-item", py: 0.5 }}>
                <ListItemText primary="Record customer signatures for every transaction." />
              </ListItem>
              <ListItem sx={{ display: "list-item", py: 0.5 }}>
                <ListItemText primary="Store documents securely as per RBI Data Protection Guidelines and PCI-DSS standards." />
              </ListItem>
            </List>

            <Typography
              variant="body1"
              paragraph
              sx={{ lineHeight: 1.6, mt: 2 }}
            >
              <strong>
                4. Liability for Chargebacks & Fraudulent Transactions:
              </strong>
            </Typography>
            <List sx={{ listStyleType: "disc", pl: 4 }} component="ul">
              <ListItem sx={{ display: "list-item", py: 0.5 }}>
                <ListItemText primary="The Client must submit documentary evidence within five (5) days of a chargeback notification." />
              </ListItem>
              <ListItem sx={{ display: "list-item", py: 0.5 }}>
                <ListItemText primary="Failure to respond allows DilliPay to debit and recover the Chargeback Amount from future settlements." />
              </ListItem>
              <ListItem sx={{ display: "list-item", py: 0.5 }}>
                <ListItemText primary="DilliPay may withhold a portion of settlement funds for 120 days after termination to cover post-termination chargebacks." />
              </ListItem>
            </List>

            <Typography
              variant="body1"
              paragraph
              sx={{ lineHeight: 1.6, mt: 2, fontStyle: "italic" }}
            >
              Any non-compliance with KYC, payment restrictions, or record
              maintenance shall make the Retailer/User solely responsible for
              resulting disputes, penalties, or losses.
            </Typography>

            {/* RESTRICTED AND PROHIBITED ACTIVITIES */}
            <Typography
              variant="h6"
              sx={{ fontWeight: "bold", mt: 3, color: "#34495e" }}
            >
              RESTRICTED AND PROHIBITED ACTIVITIES
            </Typography>
            <List sx={{ listStyleType: "disc", pl: 4 }} component="ul">
              <ListItem sx={{ display: "list-item", py: 0.5 }}>
                <ListItemText primary="DilliPay services shall not be used for unlawful or restricted activities including betting, gambling, crypto transactions, or illegal goods." />
              </ListItem>
              <ListItem sx={{ display: "list-item", py: 0.5 }}>
                <ListItemText primary="Breach of these restrictions may result in termination of services and full liability on the Retailer/User." />
              </ListItem>
            </List>

            {/* COMPLIANCE WITH LAWS AND REGULATIONS */}
            <Typography
              variant="h6"
              sx={{ fontWeight: "bold", mt: 3, color: "#34495e" }}
            >
              COMPLIANCE WITH LAWS AND REGULATIONS
            </Typography>
            <Typography variant="body1" paragraph sx={{ lineHeight: 1.6 }}>
              The Retailer/User shall comply with all applicable laws,
              including:
            </Typography>
            <List sx={{ listStyleType: "disc", pl: 4 }} component="ul">
              <ListItem sx={{ display: "list-item", py: 0.5 }}>
                <ListItemText primary="The Information Technology Act, 2000;" />
              </ListItem>
              <ListItem sx={{ display: "list-item", py: 0.5 }}>
                <ListItemText primary="The Prevention of Money Laundering Act, 2002;" />
              </ListItem>
              <ListItem sx={{ display: "list-item", py: 0.5 }}>
                <ListItemText primary="RBI and NPCI guidelines on digital payments;" />
              </ListItem>
              <ListItem sx={{ display: "list-item", py: 0.5 }}>
                <ListItemText primary="The Goods and Services Tax Act, 2017;" />
              </ListItem>
              <ListItem sx={{ display: "list-item", py: 0.5 }}>
                <ListItemText primary="Data protection and privacy laws." />
              </ListItem>
            </List>

            {/* DECLARATION BY RETAILER/USER */}
            <Typography
              variant="h6"
              sx={{ fontWeight: "bold", mt: 3, color: "#34495e" }}
            >
              DECLARATION BY RETAILER/USER
            </Typography>
            <Typography variant="body1" paragraph sx={{ lineHeight: 1.6 }}>
              I, ____________________________, S/o/D/o ________________________,
              Proprietor or Authorized Signatory of __________________________
              (Shop/Business Name), hereby declare that:
            </Typography>
            <List sx={{ listStyleType: "disc", pl: 4 }} component="ul">
              <ListItem sx={{ display: "list-item", py: 0.5 }}>
                <ListItemText primary="I have read, understood, and agreed to comply with all above terms and conditions while using DilliPay's PG & UPI/QR services." />
              </ListItem>
              <ListItem sx={{ display: "list-item", py: 0.5 }}>
                <ListItemText primary="I shall maintain all required ID proofs and transaction records." />
              </ListItem>
              <ListItem sx={{ display: "list-item", py: 0.5 }}>
                <ListItemText primary="I accept full responsibility in case of chargebacks, penalties, disputes, or fraud arising from non-compliance." />
              </ListItem>
            </List>

            {/* SIGNATURE SECTION */}
            <Box mt={4} sx={{ borderTop: "1px solid #ddd", pt: 3 }}>
              <Typography variant="body1" paragraph>
                Date:&nbsp;&nbsp;__________________________
              </Typography>
              <Typography variant="body1" paragraph>
                Place:&nbsp;&nbsp;__________________________
              </Typography>
              <Typography variant="body1" paragraph>
                Signature & Stamp:&nbsp;&nbsp;__________________________
                <br />
                (Retailer/Retailer/User)
              </Typography>

              <Typography
                variant="body1"
                paragraph
                sx={{ marginTop: 2, fontStyle: "italic" }}
              >
                IN WITNESS WHEREOF, the undersigned has executed this
                Declaration on the date first mentioned above.
              </Typography>

              <Typography variant="body1" paragraph>
                For and on behalf of [Retailer's Legal Name]
                <br />
                (Company Seal & Signature / Authorized Signatory)
                <br />
                Name:&nbsp;&nbsp;__________________________
              </Typography>
            </Box>
          </Box>
        </Page>
        {/* Signature Section */}
        <Page size="A4" style={styles.page}>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              marginTop: "30px",
            }}
          >
            <thead>
              <tr>
                <th
                  style={{
                    border: "1px solid #000",
                    padding: "12px 20px",
                    textAlign: "left",
                    backgroundColor: "#f4f4f4",
                    fontWeight: "bold",
                  }}
                >
                  For and on behalf of:
                </th>
                <th
                  style={{
                    border: "1px solid #000",
                    padding: "12px 20px",
                    textAlign: "left",
                    backgroundColor: "#f4f4f4",
                    fontWeight: "bold",
                  }}
                >
                  For and on behalf of:
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td
                  style={{
                    border: "1px solid #000",
                    padding: "12px 20px",
                    verticalAlign: "top",
                  }}
                >
                  DILLIPAY TECHNOLOGIES LIMITED
                </td>

                <td
                  style={{
                    border: "1px solid #000",
                    padding: "12px 12px",
                  }}
                >
                  Shop Name :{stateData.establishment}
                  {/* <input
                type="text"
                placeholder="Shop Name"
                style={{
                  width: "60%",
                  padding: "8px",
                  borderRadius: "4px",
                  border: "1px solid #ddd",
                  fontSize: "14px",
                }}
              /> */}
                </td>
              </tr>
              {/* <tr>
            <td
              style={{
                border: "1px solid #000",
                padding: "12px 20px",
              }}
            >
              Sd/-
            </td>
            <td
              style={{
                border: "1px solid #000",
                padding: "12px 20px",
              }}
            >
              Sd/-
            </td>
          </tr> */}
              <tr>
                <td
                  style={{
                    border: "1px solid #000",
                    padding: "12px 20px",
                  }}
                >
                  Authorised Signatory - Tarun
                </td>
                <td
                  style={{
                    border: "1px solid #000",
                    padding: "12px 20px",
                  }}
                >
                  Authorised Signatory - {stateData.name}
                </td>
              </tr>
              <tr>
                {/* <td
                  style={{
                    border: "1px solid #000",
                    padding: "12px 20px",
                  }}
                > */}
                {/* Name: */}
                {/* <input
                type="text"
                placeholder="Enter Name"
                style={{
                  width: "80%",
                  padding: "8px",
                  borderRadius: "4px",
                  border: "1px solid #ddd",
                  fontSize: "14px",
                }}
              /> */}
                {/* </td> */}
                {/* <td
                  style={{
                    border: "1px solid #000",
                    padding: "12px 20px",
                  }}
                > */}
                {/* Name:  */}
                {/* <input
                type="text"
                placeholder="Enter Name"
                style={{
                  width: "80%",
                  padding: "8px",
                  borderRadius: "4px",
                  border: "1px solid #ddd",
                  fontSize: "14px",
                }}
              /> */}
                {/* </td> */}
              </tr>
              <tr>
                <td
                  style={{
                    border: "1px solid #000",
                    padding: "12px 20px",
                  }}
                >
                  Designation: Director
                  {/* <input
                type="text"
                placeholder="Designation"
                style={{
                  width: "80%",
                  padding: "8px",
                  borderRadius: "4px",
                  border: "1px solid #ddd",
                  fontSize: "14px",
                }}
              /> */}
                </td>
                <td
                  style={{
                    border: "1px solid #000",
                    padding: "12px 20px",
                  }}
                >
                  Designation: {stateData?.role}
                  {/* <input
                type="text"
                placeholder="Designation"
                style={{
                  width: "80%",
                  padding: "8px",
                  borderRadius: "4px",
                  border: "1px solid #ddd",
                  fontSize: "14px",
                }}
              /> */}
                </td>
              </tr>
            </tbody>
          </table>
          <Box>
            <Text>Signature :</Text>
            <img src={dilliPaysign} />
          </Box>

          <h5
            style={{
              marginTop: "15px",
            }}
          >
            Date:{currentDateTime}
          </h5>
          <h5
            style={{
              marginTop: "5px",
            }}
          >
            Place: {stateData.state}
          </h5>

          <FormControlLabel
            control={
              <Checkbox
                checked={checked}
                // onChange={handleChange}
                color="primary"
                sx={{ transform: "scale(1.2)" }}
              />
            }
            label={
              <Typography
                sx={{ fontSize: "1rem", color: "#333", fontWeight: "500" }}
              >
                I accept
              </Typography>
            }
            sx={{ marginLeft: "8px" }}
          />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-end",
              justifyContent: "center",
            }}
          >
            {imageUrl && (
              <img
                src={imageUrl}
                alt="signature"
                style={{ width: "100px", height: "60px" }}
              />
            )}
            {stateData.name}
            <Text>Authorised Signatory</Text>
          </div>
          {(showForPDF || message) && (
            <>
              <Typography
                style={{
                  fontSize: "1rem",
                  // color:
                  //   message ==
                  //   `This agreement  is electronically transmitted on ${myDateDDMMTT(
                  //     date
                  //   )} from IP address ${stateData.ip}. and verified by (${
                  //     user?.establishment
                  //   }/${user?.name}) having PAN NO ${user?.pan} `
                  //     ? "green"
                  //     : "red",
                  color: stateData.type === "ret_dd" ? "green" : "red",
                  // color: "green",
                  fontWeight: "bold",
                  marginTop: "8px",
                }}
              >
                {console.log(
                  "type",
                  stateData.type,
                  stateData.type === "ret_dd"
                )}
                {message}
              </Typography>
              {message ===
              `This agreement  is electronically transmitted on ${myDateDDMMTT(
                date
              )} from IP address ${stateData.ip}. and verified by (${
                stateData?.establishment
              }/${stateData?.name}) having PAN NO ${stateData?.pan} ` ? (
                <Typography
                  style={{
                    fontSize: "1rem",
                    color: "black",
                    fontWeight: "bold",
                    marginTop: "8px",
                  }}
                >
                  date is: {myDateDDMMTT(date) || "Your have not sign Agrement"}
                </Typography>
              ) : (
                ""
              )}
            </>
          )}

          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={{
                width: 400,
                padding: 2,
                margin: "auto",
                mt: "20vh",
                borderRadius: "8px",
                boxShadow: 24,
                backgroundColor: "#fff",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <ModalHeader
                title="Retailer Agreement"
                handleClose={handleCloseModel}
              />

              <Box sx={{ flexGrow: 1, mt: 2 }}>
                {!isOtpSent && (
                  <div>
                    <TextField
                      label="Aadhaar Number"
                      name="aadhaar"
                      value={aadhaar}
                      variant="outlined"
                      required
                      fullWidth
                      onChange={(e) => setAadhaar(e.target.value)}
                      placeholder="Enter your Aadhaar number"
                      inputProps={{ maxLength: 12 }}
                      sx={{ marginBottom: 2, mt: 2 }}
                    />
                    {aadhaarError && (
                      <FormHelperText error>{aadhaarError}</FormHelperText> // Show error message below Aadhaar field
                    )}
                  </div>
                )}

                <div>
                  {isOtpSent && (
                    <div>
                      <Typography
                        sx={{
                          mb: 1,
                          ml: 1,
                        }}
                      >
                        Enter OTP
                      </Typography>
                      <PinInput
                        value={otp}
                        onChange={setOtp}
                        length={6}
                        autoComplete="off"
                        focus
                        required
                        type="password"
                        sx={{ marginBottom: 2, mt: 2 }}
                      />
                      {otpError && (
                        <FormHelperText error>{otpError}</FormHelperText> // Show error message below OTP field
                      )}
                    </div>
                  )}
                </div>
              </Box>
              {/* <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit}
                  disabled={isOtpSent ? !otp : !aadhaar}
                  sx={{ mr: 1, mt: 1 }}
                >
                  Submit
                </Button>
                <Button
                  onClick={handleClose}
                  color="secondary"
                  sx={{ mr: 1, mt: 1 }}
                >
                  Cancel
                </Button> */}

              <ModalFooter
                btn={"submit"}
                // onClick={!isOtpSent ? handleSubmit : verifyOTP}
                style={{
                  backgroundColor:
                    (isOtpSent && otp.length === 6) ||
                    (!isOtpSent && aadhaar.length === 12)
                      ? "#3f51b5"
                      : "#ddd",
                  cursor:
                    (isOtpSent && otp.length === 6) ||
                    (!isOtpSent && aadhaar.length === 12)
                      ? "pointer"
                      : "not-allowed",
                }}
              />
            </Box>
          </Modal>
        </Page>
      </div>
    </>
  );
};

export default AdminAgreement;
